module.exports = __webpack_public_path__ + "static/media/audio_and_video_settings.3a3d470a.svg";